export default "__VITE_ASSET__CcdhXaNt__"